import React, { Component } from 'react';
import { Trans, translate } from 'react-i18next';
// import { Link } from 'react-router-dom';
import Medal from '../../components/Medal'
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;

class DomicilioCard extends Component {
    handleClick(event, room) {
        event.stopPropagation();
        this.props.history.push(`${URI_VENTA_EN_LINEA}/domiclioId/domiciliopayment/${room.centro_id}`);
    }

    render() {
        const domicilio = this.props.domicilio
        // const duration = 1;
        const urlimg = "https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/";
        return (
            <div className="list-card-resvations" >
                <div className="list-card-panel-seccion">
                    <div className="content-card-panel-seccion">
                        <div className="row list list2">
                            {domicilio.map((domicilio, index) => (
                                <div className="col-lg-6 col-md-6 col-sm-12 col-12 card-panel-rooms" key={index} onClick={(e) => this.handleClick(e, domicilio)}>
                                    <div className="card-panel panel panel-default card">
                                        <div className="panel-heading">
                                            <img className="background-img" src={urlimg + domicilio.centro_id} alt="Fondo" />
                                            <Medal type={domicilio.coworks_clasificacion} />
                                        </div>
                                        <div className="card-panel-body">
                                            <div className="panel-body-title">
                                                <h4 className="ioscentro">{domicilio.centro_name.toUpperCase()}</h4>
                                            </div>
                                            <div className="panel-body-description">
                                                <div className="panel-description-text">
                                                    {'  '}{domicilio.centro_direccion}, {domicilio.centro_ciudad}
                                                    {', '}{domicilio.centro_estado}, {domicilio.centro_cp}
                                                </div>
                                                <div className="panel-description-information">
                                                    <div className="contenedor-flexbox">
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel-body-bottom">
                                                <div className="form-group">
                                                    <button
                                                        onClick={(e) => this.handleClick(e, domicilio)}
                                                        className="btn btn-block btn-primary"
                                                        type="button">
                                                            <Trans>venta_linea.index.domicilio.reserve</Trans>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    translate('common'),
    withRouter
)(DomicilioCard);


// WEBPACK FOOTER //
// ./src/store/Domicilio/DomicilioCard.js